import { FileSize, Validazioni, ConfigurazioneCaptcha } from "./../../interfaces/utilities";
import { element } from "protractor";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import {
  Juror,
  CreazioneUtenteResponse
} from "../../interfaces/juror";
import {
  FormlyFieldConfig,
  FormlyFormOptions,
  FormlyField
} from "@ngx-formly/core";
import { JurorService } from "../../services/juror.service";
import { pairwise, startWith, map, tap } from "rxjs/operators";
import {
  fileToBase64,
  substrBase64,
  showSuccessOrErrorToast,
  checkResponse,
  checkFormValidity
} from "../../utilities/utilities";
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ModalContentLiteComponent } from "../common/modal-content-lite/modal-content-lite.component";
import { SanremoRecaptchaComponent } from "../common/sanremo-recaptcha/sanremo-recaptcha.component";
import { ReCaptcha2Component } from "ngx-captcha";
import { MessageService } from "../../services/message.service";
import { ActivatedRoute, Router } from "@angular/router";
import { DettaglioCompetizione, RisorseEdizioneResponse } from "src/app/interfaces/edition";
import { EditionService } from "src/app/services/edition.service";
import { forkJoin, Observable } from "rxjs";
import { CasaDiscografica, CaseDiscograficheResponse } from "src/app/interfaces/record-company";
import { RecordCompanyService } from "src/app/services/record-company.service";
import { Canale } from "src/app/interfaces/channel";
import { Categoria } from "src/app/interfaces/category";
import { validator, errorMessage } from "src/app/utilities/validators";
import { ValidationService } from "src/app/services/validation.services";
import { LanguagesService } from "src/app/services/languages.service";
import { ConfigurationService } from "src/app/services/configuration.service";

@Component({
  selector: "app-juror-registration",
  templateUrl: "./juror-registration.component.html",
  styles: []
})
export class JurorRegistrationComponent implements OnInit {
  form = new FormGroup({});
  model = { ignoreCaptcha: false, ...new Juror() };
  fields: FormlyFieldConfig[];
  options: FormlyFormOptions = {};
  bsModalRef: BsModalRef;

  resJuror: DettaglioCompetizione;
  canali: Canale[];
  categorie: Categoria[];
  caseDiscografiche: CasaDiscografica[];
  validationList: Validazioni[];
  captchaConfiguration: ConfigurazioneCaptcha;
  dummy = false;

  private googlereCaptcha: ReCaptcha2Component;

  constructor(
    private jurorService: JurorService,
    private editionService: EditionService,
    private recordCompanyService: RecordCompanyService,
    private validationsService: ValidationService,
    private languageService: LanguagesService,
    private toastrService: ToastrService,
    private modalService: BsModalService,
    private messageService: MessageService,
    private configurationsService: ConfigurationService,
    private activeRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.messageService.reportMessage(this.languageService.getValue('juror_registration'));
    this.captchaConfiguration = this.configurationsService.configuration.value;

    forkJoin(
      this.getEditionResources(),
      this.getAllRecordCompanies()
    ).subscribe(
      (data) => {
        this.validationList = this.validationsService.validatorsList.value;
        let risorseEdizioneResponse = data[0];
        if (risorseEdizioneResponse != null && risorseEdizioneResponse != undefined) {
          this.canali = risorseEdizioneResponse.canali;
          this.categorie = risorseEdizioneResponse.categorie;
        }

        if (data[1].length > 0) {
          this.caseDiscografiche = data[1];
        }

        this.createFields();
      });

  }


  createFields() {
    this.fields = [
      {
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: 'col-2',
            type: 'select',
            defaultValue: 'Mr.',
            key: 'titolo',
            templateOptions: {
              label: this.languageService.getValue('titolo_candidatura'),
              multiple: false,
              options: [
                { label: 'Mr.', value: 'Mr.' },
                { label: 'Mrs.', value: 'Mrs.' },
              ],
            }
          },
          {
            className: "col-md-5",
            key: "cognome",
            type: "sanremo-input-lite",
            templateOptions: {
              label: this.languageService.getValue('filtro_cognome'),
              placeholder: this.languageService.getValue('filtro_cognome'),
              required: true
            },
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            }
          },
          {
            className: "col-md-5",
            key: "nome",
            type: "sanremo-input-lite",
            templateOptions: {
              label: this.languageService.getValue('filtro_nome'),
              placeholder: this.languageService.getValue('filtro_nome'),
              required: true
            },
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            }
          }
        ]
      },
      {
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: "col-md-6",
            key: "email",
            type: "input",
            templateOptions: {
              label: this.languageService.getValue("email"),
              placeholder: this.languageService.getValue("email"),
              required: true
            },
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            },
            validators: {
              email: {
                expression: (c) => validator('email', c.value, this.validationList),
                message: (error, field: FormlyFieldConfig) => errorMessage(field.formControl.value, 'email', this.languageService)
              }
            }
          },
          {
            className: "col-md-6",
            key: "telefono",
            type: "input",
            templateOptions: {
              label: this.languageService.getValue("cell"),
              placeholder: this.languageService.getValue("cell"),
              required: true
            },
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            },
            validators: {
              telefono: {
                expression: (c) => validator('cell', c.value, this.validationList),
                message: (error, field: FormlyFieldConfig) => errorMessage(field.formControl.value, 'cell', this.languageService)
              }
            }
          }
        ]
      },
      {
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: "col-md-6",
            key: "indirizzoDomicilio",
            type: "sanremo-input-lite",
            templateOptions: {
              label: this.languageService.getValue('indirizzo_principale'),
              placeholder: this.languageService.getValue('indirizzo_principale'),
              required: true
            },
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            }
          },
          {
            key: "idCasaDiscografica",
            className: "col-md-6",
            type: "select",
            templateOptions: {
              options: this.getRecordCompaniesOptions(),
              required: true,
              label: this.languageService.getValue("filtro_casaDiscografica")
            },
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            }
          }
        ]
      },
      {
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: "col-md-6",
            key: "idCanaleEdizione",
            type: "select",
            templateOptions: {
              options: this.getChannelsOptions(),
              required: true,
              label: this.languageService.getValue("canale")
            },
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            }
          },
          {
            className: "col-md-6",
            key: "idCategoriaEdizione",
            type: "select",
            templateOptions: {
              options: [{ value: "" }],

              required: true,
              label: this.languageService.getValue("categoria_candidatura")
            },
            lifecycle: {
              onInit: (form, field) => {
                const canale = form.get("idCanaleEdizione");
                field.templateOptions.options = canale.valueChanges.pipe(
                  startWith(canale.value),
                  map(v =>
                    this.getCategoriesOptions().filter(c => c.idCanaleEdizione === v)
                  ),
                  tap(() =>
                    setTimeout(() => field.formControl.setValue(null), 0)
                  )
                );
              }
            },
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            }
          }
        ]
      },
      {
        key: "note",
        type: "sanremo-area-lite",
        templateOptions: {
          label: this.languageService.getValue('note'),
          placeholder: this.languageService.getValue('note'),
          rows: 5
        }
      },
      {
        className: 'col-6 my-auto',
        key: 'inMailingList',
        type: 'checkbox',
        templateOptions: {
          label: this.languageService.getValue('inMailingList'),
          disabled: true
        }
      },
      {
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: "col-md-6",
            key: "cv",
            type: "file-input",
            templateOptions: {
              type: "file",
              label: this.languageService.getValue('cv'),
              required: true,
              callback: event => this.onDetectedFile(event, 0),
              fileName: null,
              attributes: { maxSize: 5, extraDesc: "max 5MB, PDF Preferred" }
            },
            wrappers: ["form-field", "file-wrapper-lite"],
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            }
          },
          {
            className: "col-md-6",
            key: "photo",
            type: "file-input",
            templateOptions: {
              type: "file",
              label: this.languageService.getValue('foto'),
              required: true,
              fileName: null,
              callback: event => this.onDetectedFile(event, 1),
              attributes: { maxSize: 5, extraDesc: "max 5MB" }
            },
            wrappers: ["form-field", "file-wrapper-lite"],
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            }
          }
        ]
      },
      {
        fieldGroupClassName: "row justify-content-end",
        fieldGroup: [
          {
            className: "col-md-12",

            key: "recaptcha",
            type: "sanremo-recaptcha",
            templateOptions: {
              siteKey: this.captchaConfiguration.siteKey,
              callback: (
                event: ReCaptcha2Component,
                valid: boolean
              ) => {
                this.googlereCaptcha = event;
                this.model.ignoreCaptcha = !valid;
              }
            },
            expressionProperties: {
              "templateOptions.required": "!model.ignoreCaptcha"
            },
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            },
            wrappers: ["form-field"]
          }
        ]
      }
    ];
  }

  getCategoriesOptions() {
    let options = [];
    this.categorie.forEach(value => {
      options.push({
        label: value.aliasCategoria,
        value: value.idCategoriaEdizione,
        idCanaleEdizione: value.idCanaleEdizione
      });
    });
    return options;
  }

  getChannelsOptions(): object[] {
    let options = [];
    this.canali.forEach(value => {
      options.push({
        label: value.aliasCanale,
        value: value.idCanaleEdizione
      });
    });
    return options;
  }

  getRecordCompaniesOptions(): object[] {
    let options = [];
    this.caseDiscografiche.forEach(value => {
      options.push({
        label: value.nome,
        value: value.idCasaDiscografica
      });
    });
    return options;
  }

  onDetectedFile(event: any, counter) {
    if (event.target.files.length > 0) {
      this.model.allegati[counter].nomeFile = event.target.files[0].name;
      this.model.allegati[counter].tipoAllegato = event.target.files[0].type;
      fileToBase64(event.target.files[0]).then((result) => {
        this.model.allegati[counter].urlAllegato = substrBase64(result)
      });
      let attachmentName = (event.target.files[0].name as string).split(".")[0];
      this.model.allegati[counter].nomeAllegato = attachmentName;
    }
  }

  reset() {
    this.options.resetModel();
    this.googlereCaptcha.reCaptchaApi.reset();
  }

  save() {
    let response = this.googlereCaptcha.getResponse();
    if (this.form.invalid || !response) {
			checkFormValidity(this.form);
      this.toastrService.error('', this.languageService.getValue('errore_form'), {
				disableTimeOut: true
			});
			return;
		}

    this.model.captchaResponse = response;
    this.jurorService
      .createJuror(this.model)
      .subscribe((response: CreazioneUtenteResponse) => {
        this.googlereCaptcha.reCaptchaApi.reset();
        this.form.get("recaptcha").reset();
        if (response && response.esito == 0) {
          this.options.resetModel();
          this.toastrService.success(null, this.languageService.getValue("new_user_created"));
          setTimeout(() => {
            this.router.navigate(['new-registration/registration-submitted', response.tokenSMS]);
          }, 1000)
        }
        else {
          this.toastrService.error(null, response.descrizione, {
            disableTimeOut: true
          });
        }
      });
  }

  getEditionResources(): Observable<DettaglioCompetizione> {
    return this.editionService.getRisorseEdizione().pipe(
      map((response: RisorseEdizioneResponse) => checkResponse(response, this.toastrService, "dettaglioCompetizione"))
    );
  }

  getAllRecordCompanies(): Observable<CasaDiscografica[]> {
    return this.recordCompanyService.getAllRecordCompanies().pipe(
      map((response: CaseDiscograficheResponse) => checkResponse(response, this.toastrService, "caseDiscografiche"))
    );
  }
}
